import React from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

import InformationHome from "pages/Servicii/ServiciiCuratenie/TratamentePardoseli/sections/sections/InformationHome";
import TestimonialsHome from "pages/Servicii/ServiciiCuratenie/TratamentePardoseli/sections/sections/TestimonialsHome";
import HeroSection from "pages/Servicii/ServiciiCuratenie/TratamentePardoseli/sections/sections/HeroSection";
import ServicesSection from "pages/Servicii/ServiciiCuratenie/TratamentePardoseli/sections/sections/Services";
import ArticleContent from "pages/Servicii/ServiciiCuratenie/TratamentePardoseli/sections/sections/ArticleContent";

function TratamentePardoseli() {
    return (
        <>
            <Helmet>
                <title>Tratamente Profesionale pentru Pardoseli | Întreținere & Protecție</title>
                <meta
                    name="description"
                    content="Întreținere și tratamente pentru pardoseli care redau aspectul de nou și prelungesc durata de viață: polisare, sigilare, impermeabilizare și recondiționare."
                />
                <link
                    rel="canonical"
                    href="https://doral-cleaning.ro/intretinere-si-tratamente-aplicate-pentru-pardoseli/"
                />
                <script type="application/ld+json">
                    {`
                    {
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": [
                    {
                    "@type": "Question",
                    "name": "Cât de des trebuie ceruită o pardoseală?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Se recomandă o ceruire periodică la fiecare șase luni pentru spațiile comerciale cu trafic intens."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Pot fi tratate pardoselile din lemn?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Da, folosim uleiuri și soluții dedicate care hrănesc fibra și protejează lemnul de umiditate."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Cât durează uscarea după sigilare?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Traficul trebuie oprit pentru un interval de două până la patru ore pentru a permite uscarea completă."
                    }
                    }
                    ]
                    }
                    `}
                </script>
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "LocalBusiness",
                      "@id": "https://doral-cleaning.ro/#business",
                      "name": "Doral Cleaning - Servicii profesionale de curatenie",
                      "url": "https://doral-cleaning.ro/",
                      "telephone": "0730 407 322",
                      "foundingDate": "2006",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Calea Șerban Vodă 82, Sector 4",
                        "addressLocality": "București",
                        "postalCode": "040213",
                        "addressCountry": "RO"
                      },
                      "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 44.4202372718721,
                        "longitude": 26.10209372955662
                      },
                      "areaServed": [
                        { "@type": "City", "name": "București" },
                        { "@type": "AdministrativeArea", "name": "Județul Ilfov" },
                        { "@type": "City", "name": "Voluntari" },
                        { "@type": "City", "name": "Pantelimon" },
                        { "@type": "City", "name": "Popești-Leordeni" },
                        { "@type": "City", "name": "Bragadiru" },
                        { "@type": "City", "name": "Măgurele" },
                        { "@type": "City", "name": "Chitila" },
                        { "@type": "City", "name": "Buftea" },
                        { "@type": "City", "name": "Otopeni" }
                      ]
                    }
                    `}
                </script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    zIndex: 1,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <TestimonialsHome />
                <InformationHome />
                <ArticleContent />
                <ServicesSection />
            </Card>
        </>
    );
}

export default TratamentePardoseli;
